import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { z, ZodType } from 'zod';

export function usePathParams<Z extends ZodType<any, any, any>, T = z.infer<Z>>(
  schema: Z,
): T {
  const rawParams = useParams();
  return useMemo<T>(
    function () {
      const params = schema.parse(rawParams);
      return params;
    },
    [rawParams, schema],
  );
}
